<template>
  <button v-bind="$attrs" class="button-comment"/>
</template>

<script>
export default {
  name: "ButtonComment"
}
</script>

<style scoped>
.button-comment {
  position: relative;
  border: none;
  background: url("../../../assets/static/icons/comments.svg") no-repeat center;
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  display: grid;
  place-items: center;
}

.button-comment:hover::before {
  content: "";
  position: absolute;
  display: block;
  right: 0;
  width: 1.6rem;
  height: 1.6rem;
  background: rgba(0 0 0 / 10%);
  border-radius: 50%;
}
</style>